// Auto-generated from LynxRestService project to ensure synchro of search keyword
const ContactFilteringCategoryEnum = {
  CONT: 'CONT',
  CAND: 'CAND',
  CUST: 'CUST',
  EMPL: 'EMPL',
  SALES: 'SALES',
  EXTEND_TO_NO_TEAM: 'EXTEND_TO_NO_TEAM',
  HR: 'HR',
  INVIVOO: 'INVIVOO',
  ALL: 'ALL',
  NONE: 'NONE',
  LYNXUSERS: 'LYNXUSERS'
}
export default ContactFilteringCategoryEnum
